export default {
	methods: {
		$_date_formatFull(timestamp, withHtml = true, addSeconds = false) {
			if (timestamp === '' || timestamp === null || timestamp === undefined) {
				return null
			}

			const date = new Date(timestamp * 1000)
			const formattedDate = date.getDate() + '. ' + (date.getMonth() + 1) + '. ' + date.getFullYear()
			let minutes = date.getMinutes()
			if (minutes < 10) {
				minutes = '0' + minutes
			}
			let seconds = date.getSeconds()
			if (seconds < 10) {
				seconds = '0' + seconds;
			}
			let formattedTime = date.getHours() + ':' + minutes + (addSeconds ? ':' + seconds : '');
			if (withHtml) {
				formattedTime = '<span>' + formattedTime + '</span>'
			}

			return formattedDate + ' ' + formattedTime
		},
		$_datetime_format(timestamp) {
			if (timestamp === '' || timestamp === null || timestamp === undefined) {
				return null
			}

			const date = new Date(timestamp * 1000)
			const formattedDate = date.getDate() + '. ' + (date.getMonth() + 1) + '. ' + date.getFullYear()
			let minutes = date.getMinutes()
			if (minutes < 10) {
				minutes = '0' + minutes
			}
			let seconds = date.getSeconds()
			if (seconds < 10) {
				seconds = '0' + seconds
			}
			let formattedTime = date.getHours() + ':' + minutes + ':' + seconds

			return formattedDate + ' ' + formattedTime
		},
		$_date_format(timestamp) {
			if (timestamp === '' || timestamp === null || timestamp === undefined) {
				return null
			}

			const date = new Date(timestamp * 1000)
			return date.getDate() + '. ' + (date.getMonth() + 1) + '. ' + date.getFullYear()
		},
		$_date_toTimestamp(value, hours = 0, minutes = 0, seconds = 0) {
			if (value === '' || value === null || value === undefined) {
				return null
			}

			const split = value.split('.').map(item => item.trim())

			const date = new Date()
			date.setMonth(split[1]-1)
			date.setFullYear(split[2])
			date.setDate(split[0])
			date.setHours(hours)
			date.setMinutes(minutes)
			date.setSeconds(seconds)

			//return Math.floor((date.getTime() - date.getTimezoneOffset()*60*1000) / 1000)
			return Math.floor(date.getTime() / 1000)
		},
		$_date_toMysqlFormatFromString(dateString) {
			if (dateString === '' || dateString === null || dateString === undefined) {
				return null
			}

			const split = dateString.split('.').map(item => item.trim())
			let day = split[0]
			let month = split[1]
			let year = split[2]

			return [year, month, day].join('-')
		},
		$_datetime_toMysqlFormatFromString(dateString) {
			if (dateString === '' || dateString === null || dateString === undefined) {
				return null
			}

			var split = dateString.split('.').map(item => item.trim())
			if (split.length < 3) return null;
			split = split.slice(0, 2).concat(split[2].split(' '))

			const date = this.$_date_toMysqlFormatFromString(`${split[0]}.${split[1]}.${split[2]}`)
			if (split.length < 4) {
				return date + '00:00'
			} else {
				const time = split[3].split(':')
				if (time.length < 2) return date + '00:00'
				return `${date} ${time[0]}:${time[1]}`
			}
		},
		$_formatMinutesToString(time) {
			if (time === '' || time === null || time === undefined) {
				return null
			}

			let hours = ~~(time / 60);
			let minutes = Math.round(time - (hours * 60));

			return (hours > 0 ? ((hours < 0 ? "0" + hours : hours) + " h ") : "") + (minutes > 0 ? ((minutes < 0 ? "0" + minutes : minutes) + " min") : "");
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/mixins/global/date.js